export const CREATE_WALLET_SUCCESS = 'CREATE_WALLET_SUCCESS';
export const CREATE_WALLET_REQUEST = 'CREATE_WALLET_REQUEST';
export const CREATE_WALLET_FAILURE = 'CREATE_WALLET_FAILURE';
export const createWalletSuccess = (payload) => ({
    type: CREATE_WALLET_SUCCESS,
    payload,
});
export const createWalletRequest = (payload) => ({
    type: CREATE_WALLET_REQUEST,
    payload,
});
export const createWalletFailure = (payload) => ({
    type: CREATE_WALLET_FAILURE,
    payload
});
